"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFAQAnswer = exports.StyledFAQQuestion = exports.StyledFAQQuestionWrapper = exports.StyledFAQWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const paragraph_1 = require("~components/paragraph");
exports.StyledFAQWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledFAQWrapper", componentId: "sc-1kq2qej" }) `
  ${(props) => (0, ui_1.mq)({
    paddingBottom: [0, null, props.theme.spacers.x3],
})}
`;
exports.StyledFAQQuestionWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledFAQQuestionWrapper", componentId: "sc-1kw0kmy" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.x4};
  width: 100%;
  align-items: center;

  &:hover p {
    color: ${(props) => props.theme.colors.celticBlue};
  }
`;
exports.StyledFAQQuestion = (0, styled_components_1.default)(paragraph_1.Paragraph).withConfig({ displayName: "StyledFAQQuestion", componentId: "sc-12ev8cv" }) `
  flex: 1;
  margin: 0;
  padding: ${(props) => props.theme.spacers.x3} 0;
`;
exports.StyledFAQAnswer = (0, styled_components_1.default)(paragraph_1.Paragraph).withConfig({ displayName: "StyledFAQAnswer", componentId: "sc-17ko694" }) `
  margin: 0 0 ${(props) => props.theme.spacers.x3};
  padding: 0 0 0 ${(props) => props.theme.spacers.x4};
  border-left: 5px solid ${(props) => props.theme.colors.silverPearl};
`;
